module.exports = __webpack_public_path__ + "media/images/index/product_line/sport-b63069263beccaabebfba43e01e7adf5.svg";